import React from "react";
import s from "./Bp.module.css";

export function Mobile({ children }) {
  return <div className={s["bp-mobile-only"]}>{children}</div>;
}

export function Desktop({ children }) {
  return <div className={s["bp-desktop-only"]}>{children}</div>;
}
